import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Switch,
  Typography
} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import React, {useContext, useEffect, useState} from "react";
import "../../style/datePicker.css"
import {
  submitAgentBranchSideCost,
  updateAgentBranchSideCost
} from "../../services/agent_branch_side_cost/agent_branch_side_cost";
import SelectInput from "../system/select";
import {getAgentBranchFieldAndBranchTitlesByAgentBranchIds} from "../../services/agent/agent_branch";
import {AgentBranchSideCostContext} from "../../context/agent_branch_side_cost";
import {PersianNumberInput} from "../system/persianNumberInput";

export function AgentBranchSideCostForm() {

  const {
    agentBranchSideCost,
    setAgentBranchSideCost,
    open,
    setOpen,
    setLastDataRefresh
  } = useContext(AgentBranchSideCostContext)

  const handleOpen = () => setOpen(!open);

  const [agentBranchId, setAgentBranchId] = useState(null)
  const [status, setStatus] = useState(true)
  const [cost, setCost] = useState(null)

  useEffect(() => {
    setAgentBranchId(agentBranchSideCost?.agent_branch_id ?? null)
    setStatus(agentBranchSideCost?.status === "enable")
    setCost(agentBranchSideCost?.cost ?? null)
  }, [agentBranchSideCost]);

  useEffect(() => {
    setAgentBranchSideCost(agentBranchSideCost => ({
      ...agentBranchSideCost,
      agent_branch_id: agentBranchId,
    }))
  }, [agentBranchId]);

  useEffect(() => {
    if (cost !== agentBranchSideCost?.cost) {
      setAgentBranchSideCost(agentBranchSideCost => ({
        ...agentBranchSideCost,
        cost: cost,
      }))
    }
  }, [cost]);

  const save = async () => {
    const data = agentBranchSideCost;
    if (status) {
      data.status = "enable"
    } else {
      data.status = "disable"
    }

    let result;

    if (!data.id) {
      result = await submitAgentBranchSideCost(data);
    } else {
      result = await updateAgentBranchSideCost(data);
    }

    if (result.status === 200) {
      setAgentBranchSideCost(false)
      setLastDataRefresh(Date.now())
      setAgentBranchSideCost({})
      handleOpen()
      setCost(0)
      setAgentBranchId(null)
    }
  };

  return (
    <>
      <Dialog open={open} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>ویرایش/جدید</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

          <div className="mb-4">
            <SelectInput
              label={"گرایش"}
              defaultValue={agentBranchId}
              autoLoadService={getAgentBranchFieldAndBranchTitlesByAgentBranchIds}
              autoLoadRender={({field_title, branch_title}) => {
                return field_title + " - " + branch_title
              }}
              onChange={setAgentBranchId}
            />
          </div>

          <div className="mb-4">
            <Input variant="standard"
                   value={agentBranchSideCost?.title}
                   label={Dict('title')}
                   placeholder={Dict('title')}
                   onChange={(e) => {
                     setAgentBranchSideCost(agentBranchSideCost => ({
                       ...agentBranchSideCost,
                       title: e.target.value,
                     }))
                   }}
            />
          </div>

          <div className="mb-4">
            <Input variant="standard"
                   value={agentBranchSideCost?.description}
                   label={Dict('description')}
                   placeholder={Dict('description')}
                   onChange={(e) => {
                     setAgentBranchSideCost(agentBranchSideCost => ({
                       ...agentBranchSideCost,
                       description: e.target.value,
                     }))
                   }}
            />
          </div>

          <div className="flex flex-row mb-4">
            <PersianNumberInput value={cost} label={Dict("side_cost")} setValue={setCost}
                                extension="ریال"/>
          </div>

          <div className="">
            <Switch
              label={
                <Typography color="blue-gray" className="font-medium">
                  فعال/غیرفعال
                </Typography>
              }
              checked={status}
              onChange={(e) => {
                setStatus(e.target.checked)
              }}
              labelProps={{className: "mx-4"}}
            />
          </div>
        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="gradient" color="gray" onClick={save} className="ml-1">
            <span>ذخیره</span>
          </Button>
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>انصراف</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}